<template>
  <a-modal
    :title="dataForm.id ? '编辑体检信息' : '新增体检信息'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :keyboard="false"
    :maskClosable="false"
    centered
    width="888px"
    @cancel="handleCancel"
    :getContainer="getContainer"
  >
    <div class="myForm">
      <a-form-model ref="ruleForm" :model="dataForm" :rules="rules">
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-model-item prop="person_id" ref="person_id">
              <FormItem label="姓名">
                <a-select
                  show-search
                  v-model="dataForm.person_id"
                  placeholder="姓名搜索"
                  :filter-option="false"
                  :not-found-content="fetching ? undefined : null"
                  @search="handleSearch"
                  @change="handleChange"
                  size="large"
                  :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
                >
                  <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in data" :key="d.id">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <FormItem label="年龄">
                {{ dataForm.age }}
              </FormItem>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item>
          <FormItem label="所属单位"> {{ dataForm.company_name }} </FormItem>
        </a-form-model-item>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-model-item>
              <FormItem label="身高/cm">
                <a-input
                  size="large"
                  type="number"
                  v-model="dataForm.height"
                  placeholder="请输入身高"
                ></a-input>
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <FormItem label="体重/kg">
                <a-input
                  size="large"
                  type="number"
                  v-model="dataForm.weight"
                  placeholder="请输入体重"
                ></a-input>
              </FormItem>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-model-item>
              <FormItem label="血压/mmHg">
                <a-row :gutter="10">
                  <a-col :span="12">
                    <a-input
                      size="large"
                      v-model="dataForm.sbp"
                      placeholder="收缩压"
                      type="number"
                    ></a-input>
                  </a-col>
                  <a-col :span="12">
                    <a-input
                      size="large"
                      v-model="dataForm.dbp"
                      placeholder="舒张压"
                      type="number"
                    ></a-input>
                  </a-col>
                </a-row>
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <FormItem label="心率/分次">
                <a-input
                  size="large"
                  v-model="dataForm.hr"
                  placeholder="请输入心率"
                  type="number"
                ></a-input>
              </FormItem>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { addExam, editExam, examInfo } from "@/request/health";
import { personPage } from "@/request/person";
import FormItem from "@/components/FormItem/index";
import debounce from "lodash/debounce";
export default {
  components: {
    FormItem,
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      fetching: true,
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      replaceFields: { children: "children", title: "title", key: "id" },
      data: [],
      dataForm: {
        id: "",
        name: "", //姓名
        person_id: undefined,
        uid: "", //身份证号
        company_name: "", //分包单位名称
        birthday: "",
        height: "",
        weight: "",
        sbp: "", //收缩压
        dbp: "", //舒张压
        hr: "", //脉搏
        age: "",
      },
      bf: {},
      rules: {
        person_id: [
          { required: true, message: "请选择人员", trigger: "change" },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    init(id = "") {
      this.visible = true;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      } else {
        this.fetchUser("");
      }
    },
    fetchUser(value) {
      console.log("fetching user", value);
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.data = [];
      this.fetching = true;
      personPage({ name: value }).then((d) => {
        if (fetchId !== this.lastFetchId) {
          return;
        }
        this.data = d.data.list;
        this.fetching = false;
      });
    },
    getInfo() {
      examInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
        this.data = [{ id: res.data.person_id, name: res.data.name }];
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editExam : addExam;
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改体检数据成功" : "新增体检数据成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.visible = false;
    },
    handleSearch(value) {
      this.fetchUser(value);
    },
    handleChange(value) {
      console.log(value);
      const res = this.data.find((v) => v.id == value);
      if (res) {
        console.log(res, "res");
        this.dataForm.name = res.name;
        this.dataForm.person_id = res.id;
        this.dataForm.company_name = res.company_name;
        this.dataForm.birthday = res.birthday;
        this.dataForm.uid = res.id_no;
        this.dataForm.age = res.age;
      }
      // this.value = value;
      // fetch(value, data => (this.data = data));
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
<style></style>